import { searchCommonConfig } from './common'

/**
 * SilkTale 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: '#FD9540',
  },
}
